module.exports = __webpack_public_path__ + "img/inicio-act.500abceb.svg";